/*
 * Copyright (c) Worldline 2023.
 */

export const ExternalEvidenceTempDataErrorCode = {
    TOO_MANY_PAGES: 'TOO_MANY_PAGES',
    ACCEPT_ONLY_ONE_PAGE_PDF: 'ACCEPT_ONLY_ONE_PAGE_PDF',
    CORRUPT_FILE: 'CORRUPT_FILE',
    BAD_FORMAT: 'BAD_FORMAT',
    PROCESS_ERROR: 'PROCESS_ERROR',
    TOO_BIG: 'TOO_BIG'
}